import { Box, Face, Frame, GOLD, P, Shadow } from "./hero-art-parts";

const INK = "color-mix(in oklab, var(--brand) 55%, black)";
const SOFT = "color-mix(in oklab, var(--brand-foreground) 35%, transparent)";
const pt = (x: number, y: number, z: number) => P(x, y, z).map((n) => n.toFixed(1)).join(" ");

/** Three servers stacked on a platform, lights blinking, a cloud floating above (your servers, in the cloud). */
export function InfraScene() {
  return (
    <Frame>
      <g transform="translate(145 178)">
        <Shadow x={15} y={92} rx={110} ry={34} />
        <Box x={-18} y={-18} z={-10} w={136} d={100} h={10} />
        {[0, 34, 68].map((z, i) => (
          <g key={z} className="ha-rise" style={{ animationDelay: `${i * 0.18}s` }}>
            <Box x={0} y={0} z={z} w={100} d={64} h={26} />
            <Face x={0} y={64} z={z + 26}>
              <rect x="10" y="8" width="46" height="3.5" rx="1.7" fill={INK} /><rect x="10" y="15" width="32" height="3.5" rx="1.7" fill={INK} opacity=".6" />
              <circle cx="84" cy="13" r="3.6" fill={i === 2 ? GOLD : "#6ee7a8"} className="ha-blink" style={{ animationDelay: `${i * 0.5}s` }} />
              <circle cx="72" cy="13" r="3.6" fill={SOFT} /><rect x="0" y="0" width="14" height="26" fill="var(--brand-foreground)" opacity=".5" className="ha-scan" style={{ animationDelay: `${i * 0.6}s` }} />
            </Face>
          </g>
        ))}
        {[0, 1, 2].map((k) => <circle key={k} r="3" fill={GOLD} className="ha-packet" style={{ offsetPath: `path("M${pt(30 + k * 20, 32, 96)} L${pt(50, 32, 135)}")`, animationDelay: `${k * 0.9}s` }} />)}
        <g className="ha-float">
          <path d="M-24 8a12 12 0 0 1 4-23 16 16 0 0 1 30-4 13 13 0 0 1 14 27z" transform={`translate(${pt(50, 32, 135)})`} style={{ fill: "var(--brand-foreground)" }} />
          <circle cx="15.6" cy="-90" r="30" stroke={GOLD} strokeWidth="2" className="ha-ping" />
        </g>
      </g>
    </Frame>
  );
}


/** Your network joined to the internet by an IPv4 and an IPv6 tunnel, packets going both ways, and a public address on the other side. */
export function NetworkScene() {
  const tunnels = [{ y: -26, label: "IPv4" }, { y: 26, label: "IPv6" }];
  return (
    <Frame>
      <g transform="translate(160 160)">
        <Shadow x={0} y={110} rx={130} ry={18} />
        <g transform="translate(-118 0)"><g className="ha-float2">
          <rect x="-32" y="-72" width="64" height="124" rx="12" style={{ fill: "var(--brand-foreground)" }} />
          {[-58, -26, 6].map((y) => <g key={y}><rect x="-23" y={y} width="46" height="24" rx="6" fill={INK} opacity=".85" /><circle cx="-13" cy={y + 12} r="3.5" fill="#6ee7a8" className="ha-blink" style={{ animationDelay: `${y / 50}s` }} /><rect x="-3" y={y + 9} width="18" height="6" rx="3" style={{ fill: "var(--brand-foreground)" }} opacity=".5" /></g>)}
          <text y="76" textAnchor="middle" fontSize="11" fontWeight="700" fill="var(--brand-foreground)" opacity=".8">LAN</text>
        </g></g>
        {tunnels.map((t, i) => (
          <g key={t.label}>
            <rect x="-86" y={t.y - 13} width="120" height="26" rx="13" fill="url(#ha-screen)" stroke={SOFT} strokeWidth="2" />
            <rect x="-86" y={t.y - 13} width="10" height="26" rx="4" style={{ fill: "var(--brand-foreground)" }} opacity=".7" /><rect x="24" y={t.y - 13} width="10" height="26" rx="4" style={{ fill: "var(--brand-foreground)" }} opacity=".7" />
            <circle r="4" fill={GOLD} className="ha-packet" style={{ offsetPath: `path("M-72 ${t.y - 4}H22")`, animationDelay: `${i * 0.8}s` }} />
            <circle r="4" className="ha-packet" style={{ fill: "var(--brand-foreground)", offsetPath: `path("M22 ${t.y + 4}H-72")`, animationDelay: `${i * 0.8 + 1.5}s` }} />
            <text x="-26" y={t.y + 4} textAnchor="middle" fontSize="10" fontWeight="800" fill="var(--brand-foreground)" opacity=".9">{t.label}</text>
          </g>
        ))}
        <g transform="translate(96 -14)"><g className="ha-float">
          <circle r="48" style={{ fill: "var(--brand-foreground)" }} />
          <ellipse rx="38" ry="48" stroke={INK} strokeWidth="1.6" className="ha-spin" /><ellipse rx="17" ry="48" stroke={INK} strokeWidth="1.6" className="ha-spin" style={{ animationDelay: "-3s" }} />
          <path d="M-48 0h96M-41 -23h82M-41 23h82" stroke={INK} strokeWidth="1.4" />
          <circle r="48" stroke={GOLD} strokeWidth="2" className="ha-ping" />
          <g transform="translate(18 -14)"><path d="M0 18C-14 2 -12 -12 0 -12S12 2 0 18z" fill={GOLD} /><circle cy="-3" r="4" fill={INK} /></g>
        </g></g>
        <g transform="translate(92 70)"><rect x="-52" y="-12" width="104" height="24" rx="12" fill={GOLD} /><text y="4" textAnchor="middle" fontSize="11" fontWeight="800" fill={INK}>203.0.113.7</text>
          <rect x="-52" y="18" width="104" height="22" rx="11" style={{ fill: "var(--brand-foreground)" }} /><text y="33" textAnchor="middle" fontSize="10" fontWeight="800" fill={INK}>2001:db8::7</text></g>
      </g>
    </Frame>
  );
}

/** A monitor, a tablet and a phone showing live screens: your apps on every device. */
export function AppsScene() {
  return (
    <Frame>
      <g transform="translate(146 178)">
        <Shadow x={10} y={62} rx={125} ry={36} />
        <Box x={-30} y={-20} z={-8} w={160} d={130} h={8} />
        <Box x={32} y={12} z={0} w={34} d={18} h={4} /><Box x={44} y={20} z={4} w={12} d={5} h={14} />
        <g className="ha-rise">
          <Box x={6} y={16} z={18} w={86} d={6} h={54} />
          <Face x={6} y={22} z={72}>
            <rect x="4" y="4" width="78" height="46" rx="4" fill="url(#ha-screen)" />
            {[12, 30, 48, 66].map((x, i) => <rect key={x} x={x} y={44 - [14, 24, 18, 30][i]} width="9" height={[14, 24, 18, 30][i]} rx="2" fill="var(--brand-foreground)" opacity={i === 3 ? 1 : 0.6} className="ha-grow" style={{ animationDelay: `${i * 0.5}s` }} />)}
            <rect x="12" y="9" width="30" height="3" rx="1.5" fill="var(--brand-foreground)" /><circle cx="74" cy="10.5" r="2.5" fill={GOLD} className="ha-blink" />
          </Face>
        </g>
        <g className="ha-float2">
          <Box x={92} y={44} z={0} w={46} d={4} h={40} />
          <Face x={92} y={48} z={40}>
            <rect x="3" y="3" width="40" height="34" rx="3" fill="url(#ha-screen)" />
            <rect x="8" y="9" width="22" height="3" rx="1.5" fill="var(--brand-foreground)" className="ha-type" /><rect x="8" y="17" width="30" height="3" rx="1.5" fill="var(--brand-foreground)" opacity=".6" className="ha-type" style={{ animationDelay: ".4s" }} /><rect x="8" y="25" width="16" height="5" rx="2.5" fill={GOLD} className="ha-pulse" />
          </Face>
        </g>
        <g className="ha-float">
          <Box x={-18} y={48} z={0} w={16} d={4} h={34} />
          <Face x={-18} y={52} z={34}>
            <rect x="1.5" y="1.5" width="13" height="31" rx="2.5" fill="url(#ha-screen)" /><circle cx="8" cy="12" r="3.5" fill={GOLD} className="ha-blink" /><rect x="4" y="22" width="8" height="2" rx="1" fill="var(--brand-foreground)" />
          </Face>
        </g>
      </g>
    </Frame>
  );
}

/** Three browser windows fanned in depth, the front one with a headline, a hero block, a button and cards: websites built around what you sell. */
export function WebScene() {
  return (
    <Frame>
      <g transform="translate(135 178)">
        <Shadow x={30} y={88} rx={110} ry={32} />
        {[0, 1, 2].map((i) => (
          <g key={i} className={i === 2 ? "ha-float" : undefined}>
            <g className="ha-rise" style={{ animationDelay: `${i * 0.25}s` }}>
              <Box x={i * 22} y={i * 30} z={0} w={112} d={6} h={88} />
              <Face x={i * 22} y={i * 30 + 6} z={88}>
                <rect x="0" y="0" width="112" height="14" fill={INK} opacity=".55" /><circle cx="8" cy="7" r="2.2" fill={GOLD} /><circle cx="16" cy="7" r="2.2" fill={SOFT} /><circle cx="24" cy="7" r="2.2" fill={SOFT} />
                {i === 2 && (
                  <>
                    <rect x="8" y="20" width="96" height="30" rx="5" fill="url(#ha-screen)" />
                    <rect x="16" y="27" width="52" height="4" rx="2" fill="var(--brand-foreground)" className="ha-type" style={{ animationDelay: ".7s" }} /><rect x="16" y="35" width="34" height="4" rx="2" fill="var(--brand-foreground)" opacity=".6" className="ha-type" style={{ animationDelay: "1.1s" }} />
                    <rect x="74" y="31" width="24" height="9" rx="4.5" fill={GOLD} className="ha-pulse" />
                    <rect x="8" y="56" width="45" height="26" rx="5" fill={INK} opacity=".35" /><rect x="59" y="56" width="45" height="26" rx="5" fill={INK} opacity=".35" />
                  </>
                )}
                {i < 2 && <rect x="8" y="20" width="96" height="30" rx="5" fill={INK} opacity=".3" />}
              </Face>
            </g>
          </g>
        ))}
      </g>
    </Frame>
  );
}
